import React from 'react';
import { useHistory } from 'react-router-dom';
import { t } from '../../../../../utils/helpers';
import MainButton from '@ui-kit/components/mainButton';
import { container } from 'tsyringe';
import { IGameProvider, ITable } from '@base/features/game/model/interfaces';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { ITableSettingsService } from '@base/features/table/interfaces';
import PlayersOnlineRepository from '@base/features/player/model/playersOnlineRepository';
import BaseTablesRepository from '@base/features/game/model/baseTableRepository';
import useSession from '@base/utils/hooks/useSession';
import { ISocketClient } from '@base/features/socket/interfaces';
import { TournamentsService } from '@base/features/tournaments/model/interfaces';
import { ResponseCode } from '@base/utils/constants';
import CreateTableService from '@base/features/createTable/model/createTableService';

export const TournamentConnectButton = (props: {
  host: string;
  port: number;
  tourneyID: string;
  proxy: string;
}) => {
  const socketClient: ISocketClient = container.resolve('socketClient');
  const playersOnlineRepository: PlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const tablesRepository: BaseTablesRepository<ITable> = container.resolve('tableRepository');
  const createTableService: CreateTableService = container.resolve('createTableService');
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  const tournamentsService: TournamentsService = container.resolve('tournamentsService');
  const history = useHistory();
  const session = useSession();

  function connectTournamentRoom() {
    if (!session) return;
    socketClient.connect({
      host: props.host,
      port: props.port,
      usr: session.usr,
      session: session.session,
      proxy: props.proxy,
    });
    playersOnlineRepository.clear();
    tablesRepository.cleanTables();
    tournamentsService.getTournamentOptions(props.tourneyID).then((response) => {
      if (response && response.code === ResponseCode.SUCCESS) {
        // response.tc Это массив, где 
        // первое значение это maxPoints (121 или 61 для крибиджа)
        // Второе значение это минуты на ход
        // Третье значение это minPoints

        const [maxPoints, timePerMove, minPoints] = gameProvider.parseTournamentSettings(response.tc);
        createTableService.handlerMaxPoints(maxPoints);
        createTableService.handlerTimePerMove(timePerMove);
        createTableService.handlerMinPoints(minPoints);
      }
      history.push(MAIN_ROUTES.lobby);
    });
  }

  const buttonIsVisible =
    socketClient.isConnectedToDefault() && !socketClient.isConnectedTo(props.host, props.port);

  return (
    <div className="tournaments__item-start">
      {buttonIsVisible && (
        <MainButton className="tourney-btn-enter" onClick={connectTournamentRoom}>
          {t('enter')}
        </MainButton>
      )}
    </div>
  );
};
